<template>
  <BaseModal
        :id="'validations'"
        :title="`Validations`"
        :size="'lg'"
        :message="message"
        @close="close($event)"
    >

        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb_local"/>
        </template>

        <template v-slot:content> 
            <div class="w-100 table-responsive defaultproject__table overflow-y--2">
                <table class="table">
                    <thead>
                        <tr>
                            <th v-for="(item, i) in summary_table_headers" :key="i" scope="col" v-html="item.name"/>
                        </tr>
                    </thead>
                    <tbody>
                        <template>
                                <tr v-for="(item, i) in  validate_data" :key="i">
                                    <td v-html="`${(i+1)}`"/>
                                    <td v-html="item.description"/>
                                    <td v-html="item.task_name"/>
                                    <td v-html="item.project"/>
                                    <td v-html="item.project_number"/>
                                </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal            from    '@/components/BaseModal'

export default {
    name: 'ValidationsModal',

    props: [
        'breadcrumb',
        'validate_data',
    ],

    components: {
        BaseModal,
        Breadcrumb,
    },

    data() {
        return {
            summary_table_headers: [
                { 
                    name:   '#',
                },
                {   
                    name:   'Description',
                },
                {
                    name:   'Task',
                },
                {
                    name:   "Project's Name",
                },
                {
                    name: "Project #"

                },
            ],
            breadcrumb_local: [...this.breadcrumb],
            message: 'The following room-tasks have already been added to a project',
        };
    },

    methods: {
       close(event) {
           this.$emit('close', event)
       }
    },

    computed: {

    },

    mounted(){
        this.breadcrumb_local[this.breadcrumb.length - 1].arrow =  "<span class='slash'>/</span>"
        this.breadcrumb_local.push({
            name: 'Validation Modal',
            arrow: "",
        })
    }
}
</script>